import { EntityListActions } from 'actions';
import Context from 'managers/Context';
import { publish } from 'lib/EventBuser';
import { UPDATE_ROW } from 'lib/events';
import { NOOP_SET_MARKETING_CONSENT } from './column';
import { getMarketingStatusRowPatchFields } from './marketingStatusRow';

export {
    getMarketingStatusIdFromRow,
    getMarketingStatusRowPatchFields,
} from './marketingStatusRow';

/**
 * Keeps Redux entity list and ag-grid infinite cache in sync after a status change
 * (avoids stale marketing status when virtualized rows are recycled).
 */
export function patchMarketingStatusRow(entity, id, marketingStatusId) {
    if (!entity || id == null || id === '') return;

    const fields = getMarketingStatusRowPatchFields(marketingStatusId);
    Context.store.dispatch(EntityListActions.updateRowFields(entity, id, fields));
    publish(`${UPDATE_ROW}_${entity.entity}`, { id, fields });
}

export function createSetMarketingConsentWithRowPatch(setMarketingConsent, entity) {
    if (!entity || setMarketingConsent === NOOP_SET_MARKETING_CONSENT) {
        return setMarketingConsent;
    }

    return async (args) => {
        const result = await setMarketingConsent(args);
        patchMarketingStatusRow(entity, args.id, args.marketingStatusId);
        return result;
    };
}
